import React, { useEffect, useState } from "react";
// import axios from "axios";
import axios from "../context/axios";
import toast, { Toaster } from "react-hot-toast";

const UserProfile = () => {
  const storedUser = localStorage.getItem("user");
  const userId = storedUser ? JSON.parse(storedUser)._id : null;

  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    country: "",
    businessName: "",
    pic: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.post("/users/getUserById", { userId });
        setUser(res.data);
        setFormData({
          name: res.data.name || "",
          mobile: res.data.mobile || "",
          email: res.data.email || "",
          country: res.data.country || "",
          businessName: res.data.businessName || "",
          pic: res.data.pic || "",
        });
      } catch (err) {
        console.error("Error fetching user:", err);
        toast.error("Failed to load profile");
      } finally {
        setLoading(false);
      }
    };

    if (userId) fetchUser();
  }, [userId]);

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Invalid email format";
    if (!formData.mobile.trim()) newErrors.mobile = "Mobile number is required";
    else if (!/^\d{10}$/.test(formData.mobile))
      newErrors.mobile = "Must be 10 digits";
    if (!formData.country.trim()) newErrors.country = "Country is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData((prev) => ({ ...prev, pic: reader.result })); // base64 string
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId) {
      toast.error("User not logged in");
      return;
    }
    if (!validate()) return;

    try {
      setSubmitting(true);
      const res = await axios.put(`/users/updateprofile/${userId}`, formData);
      setUser(res.data);
      toast.success("Profile updated successfully!");
    } catch (err) {
      console.error("Error updating profile:", err);
      toast.error("Failed to update profile");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading)
    return (
      <p className="text-center mt-10 text-gray-500">Loading profile...</p>
    );

  return (
    <div className="max-w-4xl mx-auto mt-10 mb-20 px-4">
      <Toaster position="top-right" reverseOrder={false} />

      <div className="bg-white shadow-lg rounded-xl p-6 md:p-10">
        <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
          <div className="flex flex-col items-center md:w-1/3">
            <label className="cursor-pointer relative w-32 h-32 md:w-40 md:h-40 mb-4">
              <img
                src={
                  formData.pic ||
                  "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
                }
                alt="Profile"
                className="rounded-full object-cover border-4 border-blue-500 w-full h-full"
              />
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="absolute inset-0 opacity-0 cursor-pointer"
              />
            </label>
          </div>

          <form onSubmit={handleSubmit} className="md:w-2/3 w-full space-y-5">
            <h2 className="text-2xl font-semibold text-blue-700 border-b pb-2">
              Edit Your Details
            </h2>

            {[
              { label: "Full Name", name: "name", type: "text" },
              { label: "Email", name: "email", type: "email" },
              { label: "Mobile Number", name: "mobile", type: "text" },
              { label: "Country", name: "country", type: "text" },
            ].map(({ label, name, type }) => (
              <div key={name}>
                <label className="block text-sm font-medium mb-1">
                  {label}
                </label>
                <input
                  type={type}
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  className={`border px-4 py-2 rounded w-full ${
                    errors[name] ? "border-red-500" : "border-gray-300"
                  }`}
                  {...(name === "email" ? { readOnly: true } : {})} 
                />
                {errors[name] && (
                  <p className="text-red-600 text-sm mt-1">{errors[name]}</p>
                )}
              </div>
            ))}

            <button
              type="submit"
              disabled={submitting}
              className={`bg-blue-600 text-white px-6 py-2 rounded w-full hover:bg-blue-700 transition ${
                submitting ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {submitting ? "Updating..." : "Update Profile"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
